import {Dialog, IconButton} from "@mui/material";
import {Grid} from "@mui/system";
import {useEffect, useState} from "react";
import {Close} from '@mui/icons-material'

export const useAnuncio = ({Componente, clave, retrazo = 0, seccionesNoMostrar = [], mostrar='No'}) => {

    const [open, setOpen] = useState(false);


    const cerrar = () => {
        setOpen(false);
    }

    const Anuncio = () => {

        return (
            <Dialog open={open} fullWidth maxWidth={'xs'} keepMounted scroll={'body'}>
                <Grid
                    container
                    justifyContent={'flex-start'}
                    alignItems={'flex-start'}
                    size={{xs: 12, sm: 12, md: 12}}>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-end'}}>
                        <IconButton>
                            <Close onClick={() => setOpen(false)}/>
                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                        <Componente cerrar={cerrar}/>
                    </Grid>

                </Grid>
            </Dialog>
        )
    }

    useEffect(() => {


        let seccion = window.location.pathname
        let path = obtenerSeccion(seccion)


        if (path && seccionesNoMostrar.includes(path)) {

        } else {
            setTimeout(() => {
                if (mostrar === 'Si'){
                    setOpen(true)
                }
            }, retrazo)
        }


    }, []);
    return {
        Anuncio
    }

}

const obtenerSeccion = (camino) => {

    let seccion = camino.split('/')[1]

    return seccion
}